import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HcaGeneralComponent} from './hca-general/hca-general.component';
import {HcaSettingsComponent} from './hca-settings/hca-settings.component';
import {AuthGuard} from '../../../../shared/_guards/auth.guard';
import {HcaUserManagementListComponent} from './hca-user-management/hca-user-management-list/hca-user-management-list.component';
import {HcaUserManagementDetailsComponent} from './hca-user-management/hca-user-management-details/hca-user-management-details.component';
import {HcaBrandComponent} from './hca-brand/hca-brand.component';
import {HcaLoyaltyProgramsComponent} from './hca-loyalty-programs/hca-loyalty-programs.component';
import {HcaUserManagementAddComponent} from './hca-user-management/hca-user-management-add/hca-user-management-add.component';
import {HcaLoyaltyWebsiteMainComponent} from './hca-loyalty-website/hca-loyalty-website-main/hca-loyalty-website-main.component';
import {HcaLoyaltyWebsitePreviewComponent} from './hca-loyalty-website/hca-loyalty-website-preview/hca-loyalty-website-preview.component';
import {HcaHistoryChangesListComponent} from './hca-history-changes/hca-history-changes-list/hca-history-changes-list.component';


const routes: Routes = [
  {
    path: 'settings', component: HcaSettingsComponent, canActivate: [AuthGuard],
    children: [
      {path: 'hca-user-management', pathMatch: 'full', component: HcaUserManagementListComponent, canActivate: [AuthGuard]},
      {path: 'hca-user-management/add', pathMatch: 'full', component: HcaUserManagementAddComponent, canActivate: [AuthGuard]},
      {path: 'hca-user-management/edit/:id', pathMatch: 'full', component: HcaUserManagementDetailsComponent, canActivate: [AuthGuard]},
      {path: 'hca-general', pathMatch: 'full', component: HcaGeneralComponent},
      {path: 'hca-brand', pathMatch: 'full', component: HcaBrandComponent},
      {path: 'hca-loyalty-programs', pathMatch: 'full', component: HcaLoyaltyProgramsComponent},
      {path: 'hca-loyalty-website', pathMatch: 'full', component: HcaLoyaltyWebsiteMainComponent},
      {path: 'hca-history-changes', pathMatch: 'full', component: HcaHistoryChangesListComponent},
    ]
  },
  {path: 'hca-loyalty-website-preview', component: HcaLoyaltyWebsitePreviewComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/settings-routing.module.ts